(function(){
  "use strict";

  if(window.__ptbirthqB2CUxGuardV1) return;
  window.__ptbirthqB2CUxGuardV1 = true;

  var scheduled = false;
  var rootObserver = null;
  var observedRoot = null;
  var focusWasOpen = false;
  var pageStyle = null;

  function cleanName(value){
    return String(value || "")
      .replace(/\[\[ptemoji:[^\]]+\]\]/g, "")
      .replace(/[\u2600-\u27bf]/g, "")
      .replace(/[\ud83c-\udbff][\udc00-\udfff]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 40);
  }

  function setText(element, value){
    if(element && element.textContent !== value) element.textContent = value;
  }

  function setAttr(element, name, value){
    if(element && element.getAttribute(name) !== String(value)) element.setAttribute(name, String(value));
  }

  function track(eventType, detail){
    try{
      window.__ptBirthQuickAnalyticsEvents = window.__ptBirthQuickAnalyticsEvents || [];
      window.__ptBirthQuickAnalyticsEvents.push({ event_type:eventType, detail:detail, at:new Date().toISOString() });
      if(window.__ptBirthQuickAnalyticsEvents.length > 40) window.__ptBirthQuickAnalyticsEvents.shift();
    }catch(ignore){}
    try{
      if(window.PTAnalytics && typeof window.PTAnalytics.track === "function"){
        window.PTAnalytics.track(eventType, detail || {}, { context:{ surface:"b2c_quickview" } });
      }
    }catch(ignore){}
  }

  function syncHero(root){
    var form = root.querySelector("[data-ptbirthq-hero-wizard]");
    var submit = root.querySelector("[data-ptbirthq-home-start-submit]");
    if(form && submit && root.getAttribute("data-ptbirthq-name-first") !== "1"){
      var step = parseInt(form.getAttribute("data-ptbirthq-hero-step") || "0", 10) || 0;
      var three = root.getAttribute("data-ptbirthq-question-count") === "3";
      var label = three ? (step >= 2 ? "Vorschau erstellen" : (step === 1 ? "Weiter zum Anlass" : "Weiter")) : (step === 0 ? "Vorschau erstellen" : (step >= 3 ? "Zertifikat ansehen" : "Weiter"));
      setText(submit, label);
      setAttr(submit, "aria-label", label);
    }

    var auto = root.querySelector("#ptbirthq-auto-run");
    if(auto && /^Los!?$/i.test(String(auto.textContent || "").trim())){
      setText(auto, "Vorschau erstellen");
      setAttr(auto, "aria-label", "Vorschau erstellen");
    }
    var ready = root.querySelector("[data-ptbirthq-boot-ready]");
    if(ready){
      setText(ready, "Jetzt bearbeiten");
      setAttr(ready, "aria-label", "Jetzt Zertifikat bearbeiten");
    }
    var preview = root.querySelector("#ptbirthq-preview-open");
    if(preview){
      setText(preview, "Vorschau");
      setAttr(preview, "aria-label", "Vorschau");
    }
  }

  function isVisible(element){
    if(!element || element.hidden || !element.isConnected) return false;
    try{
      var style = window.getComputedStyle(element);
      return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
    }catch(error){ return false; }
  }

  function syncResume(root){
    var activeResume = root.getAttribute("data-ptbirthq-home-result") === "1" &&
      root.getAttribute("data-ptbirthq-focus-resume") === "1";
    var savedDraft = root.getAttribute("data-ptbirthq-saved-draft") === "1" &&
      root.getAttribute("data-ptbirthq-saved-draft-dismissed") !== "1";
    var previewRecipient = root.querySelector("#ptbirthq-preview-recipient");
    var recipient = activeResume ? cleanName(previewRecipient && previewRecipient.textContent) :
      cleanName(root.getAttribute("data-ptbirthq-saved-draft-recipient"));
    var title = root.querySelector("[data-ptbirthq-resume-title]");
    var resume = root.querySelector("#ptbirthq-focus-resume");
    var restart = root.querySelector("#ptbirthq-focus-restart");
    var savedResume = root.querySelector("[data-ptbirthq-saved-draft-resume]");

    if(activeResume){
      setText(title, recipient ? ("Dein Zertifikat für " + recipient) : "Dein Zertifikat weiterbearbeiten");
      setText(resume, recipient ? ("Entwurf für " + recipient + " fortsetzen") : "Entwurf fortsetzen");
      setText(restart, "Neues Zertifikat beginnen");
      setAttr(resume, "aria-label", resume && resume.textContent);
      setAttr(restart, "aria-label", "Neues Zertifikat beginnen");
    }else if(savedDraft){
      setText(title, recipient ? ("Dein Entwurf für " + recipient + " wartet") : "Dein Entwurf wartet");
      setText(savedResume, recipient ? ("Entwurf für " + recipient + " fortsetzen") : "Entwurf fortsetzen");
    }

    if(savedResume){
      var url = root.getAttribute("data-ptbirthq-saved-draft-url") || "#pt-birth-quick";
      if(savedResume.getAttribute("href") !== url) savedResume.setAttribute("href", url);
      setAttr(savedResume, "aria-label", savedResume.textContent);
    }
  }

  function syncTools(root){
    var toggle = root.querySelector("#ptbirthq-guides-toggle");
    if(!toggle) return;
    var expanded = toggle.getAttribute("aria-pressed") === "true";
    var label = expanded ? "Ausblenden" : "Einblenden";
    setText(toggle.querySelector(".ptbirthq-toolsToggleLabel"), label);
    setAttr(toggle, "aria-label", label);
    setAttr(toggle, "title", label);
  }

  function syncOccasions(root){
    [
      { container:".ptbirthq-homeHeroNameChips", option:"[data-ptbirthq-home-occasion-chip]", value:"data-ptbirthq-home-occasion-chip", extra:"data-ptbirthq-home-occasion-extra", input:"#ptbirthq-home-hero-occasion", more:"[data-ptbirthq-home-occasion-more]" },
      { container:".ptbirthq-autoOccasionChips", option:"[data-ptbirthq-auto-occasion]", value:"data-ptbirthq-auto-occasion", extra:"data-ptbirthq-auto-occasion-extra", input:"#ptbirthq-auto-occasion", more:"[data-ptbirthq-auto-occasion-more]" }
    ].forEach(function(config){
      var container = root.querySelector(config.container);
      var input = root.querySelector(config.input);
      if(!container || !input) return;
      var current = String(input.value || "").replace(/\s+/g, " ").trim().toLowerCase();
      var selectedExtra = false;
      Array.prototype.forEach.call(container.querySelectorAll(config.option), function(option){
        var value = String(option.getAttribute(config.value) || option.textContent || "")
          .replace(/\s+/g, " ").trim().toLowerCase();
        var selected = !!current && value === current;
        option.classList.toggle("is-selected", selected);
        setAttr(option, "aria-pressed", selected ? "true" : "false");
        if(selected && option.hasAttribute(config.extra)) selectedExtra = true;
      });
      if(selectedExtra && !container.classList.contains("is-more-open")) container.classList.add("is-more-open");
      var more = container.querySelector(config.more);
      if(more){
        var open = container.classList.contains("is-more-open");
        setAttr(more, "aria-expanded", open ? "true" : "false");
        setText(more, open ? "Weniger" : "Weitere");
      }
    });
  }

  function priceFrom(element){
    var match = String(element && element.textContent || "").replace(/\s+/g, " ").match(/([0-9]+(?:[.,][0-9]{1,2})?)\s*€/);
    return match ? match[1] + " €" : "";
  }

  function syncPurchase(root){
    var buy = root.querySelector("#ptbirthq-stage-buy");
    var price = priceFrom(buy);
    [buy, root.querySelector("#ptbirthq-stage-buy-panel-copy")].forEach(function(button){
      if(!button) return;
      var buttonPrice = priceFrom(button) || price;
      if(buttonPrice) setAttr(button, "data-ptbirthq-display-price", buttonPrice);
      /* The final-step module owns these labels when installed. Two writers
         with different labels otherwise keep waking each other's observers. */
      if(!root.__ptbirthqPayPalFinalStep) setAttr(button, "aria-label", "Geschenk und Versand wählen" + (buttonPrice ? " – " + buttonPrice : ""));
    });
    var paypal = root.querySelector("#ptbirthq-paypal");
    if(paypal && root.getAttribute("data-ptbirthq-purchase-flow") === "0" && root.getAttribute("data-ptbirthq-locked-gift") !== "1"){
      var paypalPrice = priceFrom(paypal) || price;
      if(paypalPrice) setAttr(paypal, "data-ptbirthq-display-price", paypalPrice);
      if(!root.__ptbirthqPayPalFinalStep) setAttr(paypal, "aria-label", "Nur PDF? Direkt mit PayPal" + (paypalPrice ? " – " + paypalPrice : ""));
      var main = paypal.querySelector(".ptbirthq-paypalFirstMain");
      if(main && paypalPrice) setAttr(main, "data-ptbirthq-display-price", paypalPrice);
    }
  }

  function focusModeIsOpen(root){
    return !!(root && root.isConnected && !root.hidden && root.getAttribute("data-ptbirthq-focus-mode") === "1");
  }

  function repairFocusClasses(root){
    var open = focusModeIsOpen(root);
    if(!focusWasOpen && !open && document.body){
      pageStyle = {
        body:{
          position:document.body.style.position,
          top:document.body.style.top,
          left:document.body.style.left,
          right:document.body.style.right,
          width:document.body.style.width,
          overflow:document.body.style.overflow,
          background:document.body.style.background
        },
        html:{
          overflow:document.documentElement.style.overflow,
          background:document.documentElement.style.background
        }
      };
    }
    if(open){
      focusWasOpen = true;
      return;
    }
    if(document.documentElement.classList.contains("ptbirthqQuickFocusOpen")) document.documentElement.classList.remove("ptbirthqQuickFocusOpen");
    if(document.body && document.body.classList.contains("ptbirthqQuickFocusOpen")) document.body.classList.remove("ptbirthqQuickFocusOpen");
    if(focusWasOpen && pageStyle && document.body){
      Object.keys(pageStyle.body).forEach(function(key){ document.body.style[key] = pageStyle.body[key] || ""; });
      Object.keys(pageStyle.html).forEach(function(key){ document.documentElement.style[key] = pageStyle.html[key] || ""; });
    }
    focusWasOpen = false;
  }

  function sync(){
    scheduled = false;
    var root = document.getElementById("pt-birth-quick");
    if(root !== observedRoot){
      if(rootObserver) rootObserver.disconnect();
      observedRoot = root;
      if(root){
        rootObserver = new MutationObserver(schedule);
        rootObserver.observe(root, {
          childList:true,
          subtree:true,
          characterData:true,
          attributes:true,
          attributeFilter:[
            "data-ptbirthq-hero-step", "data-ptbirthq-home-result", "data-ptbirthq-focus-mode",
            "data-ptbirthq-focus-resume", "data-ptbirthq-saved-draft", "data-ptbirthq-saved-draft-url",
            "data-ptbirthq-saved-draft-recipient", "data-ptbirthq-purchase-flow", "data-ptbirthq-locked-gift",
            "aria-pressed", "hidden"
          ]
        });
      }
    }
    if(root){
      syncHero(root);
      syncResume(root);
      syncTools(root);
      syncOccasions(root);
      syncPurchase(root);
    }
    repairFocusClasses(root);
  }

  function schedule(){
    if(scheduled) return;
    scheduled = true;
    if(window.requestAnimationFrame) window.requestAnimationFrame(sync);
    else window.setTimeout(sync, 0);
  }

  var greetModalClosingTimer = 0;

  function guardGreetingModalCloseTouch(event){
    var modal = document.getElementById("ptbirthq-modal");
    if(!modal || !modal.classList.contains("is-open") ||
      (!modal.classList.contains("is-greet-text-zoom") && !modal.classList.contains("is-greet-card-zoom"))) return;
    var close = event.target && event.target.closest ? event.target.closest(
      "[data-ptbirthq-greet-text-zoom-close], [data-ptbirthq-greet-text-zoom-done], [data-ptbirthq-greet-card-zoom-close], #ptbirthq-modal-close"
    ) : null;
    if(!close || !modal.contains(close)) return;

    event.preventDefault();
    event.stopPropagation();
    if(event.stopImmediatePropagation) event.stopImmediatePropagation();

    document.documentElement.classList.add("ptbirthqGreetModalClosing");
    if(document.body) document.body.classList.add("ptbirthqGreetModalClosing");
    if(greetModalClosingTimer) window.clearTimeout(greetModalClosingTimer);
    greetModalClosingTimer = window.setTimeout(function(){
      document.documentElement.classList.remove("ptbirthqGreetModalClosing");
      if(document.body) document.body.classList.remove("ptbirthqGreetModalClosing");
      greetModalClosingTimer = 0;
    }, 700);

    close.click();
  }

  document.addEventListener("touchend", guardGreetingModalCloseTouch, { capture:true, passive:false });

  document.addEventListener("click", function(event){
    var reviewLink = event.target && event.target.closest ? event.target.closest(".ptbirthq-homeHeroReviewLink, .ptbirthq-homeHeroReviewTextLink") : null;
    if(reviewLink){
      track("review_link_click", {
        surface:"home_hero",
        platform:reviewLink.classList.contains("ptbirthq-homeHeroReviewLink--trustpilot") ? "trustpilot" : "google",
        trigger:"link"
      });
    }
    var preview = event.target && event.target.closest ? event.target.closest("#ptbirthq-preview-open") : null;
    if(preview){
      track("preview_open", {
        surface:"quickview",
        action_target:"beautiful_preview",
        trigger:"button"
      });
    }
    var homeChip = event.target && event.target.closest ? event.target.closest("[data-ptbirthq-home-occasion-chip]") : null;
    var autoChip = event.target && event.target.closest ? event.target.closest("[data-ptbirthq-auto-occasion]") : null;
    var chip = homeChip || autoChip;
    if(chip){
      var root = document.getElementById("pt-birth-quick");
      if(!root || !root.contains(chip)) return;
      var input = homeChip ? root.querySelector("#ptbirthq-home-hero-occasion") : root.querySelector("#ptbirthq-auto-occasion");
      if(!input) return;
      event.preventDefault();
      event.stopPropagation();
      if(event.stopImmediatePropagation) event.stopImmediatePropagation();
      var value = String(chip.getAttribute(homeChip ? "data-ptbirthq-home-occasion-chip" : "data-ptbirthq-auto-occasion") || chip.textContent || "").trim().slice(0, 120);
      input.value = value;
      input.removeAttribute("aria-invalid");
      if(autoChip) setAttr(input, "data-ptbirthq-auto-pristine", "0");
      Array.prototype.forEach.call(chip.parentElement.querySelectorAll(homeChip ? "[data-ptbirthq-home-occasion-chip]" : "[data-ptbirthq-auto-occasion]"), function(option){
        var selected = option === chip;
        option.classList.toggle("is-selected", selected);
        setAttr(option, "aria-pressed", selected ? "true" : "false");
      });
      input.dispatchEvent(new Event("input", { bubbles:true }));
      input.dispatchEvent(new Event("change", { bubbles:true }));
      track(homeChip ? "home_hero_field_suggestion" : "landing_guide_occasion_selected", {
        surface:"quickview",
        slot:"occasion",
        trigger:"occasion_chip",
        value_length:value.length
      });
      schedule();
      return;
    }

    var more = event.target && event.target.closest ? event.target.closest(
      "[data-ptbirthq-home-occasion-more], [data-ptbirthq-auto-occasion-more]"
    ) : null;
    if(more){
      event.preventDefault();
      var container = more.closest(".ptbirthq-homeHeroNameChips, .ptbirthq-autoOccasionChips");
      var open = !(container && container.classList.contains("is-more-open"));
      if(container) container.classList.toggle("is-more-open", open);
      setAttr(more, "aria-expanded", open ? "true" : "false");
      setText(more, open ? "Weniger" : "Weitere");
      return;
    }

    var startNew = event.target && event.target.closest ? event.target.closest("[data-ptbirthq-saved-draft-new]") : null;
    if(startNew){
      var root = document.getElementById("pt-birth-quick");
      if(!root || !root.contains(startNew)) return;
      event.preventDefault();
      root.setAttribute("data-ptbirthq-saved-draft-dismissed", "1");
      var first = root.querySelector("[data-ptbirthq-home-start-input]");
      window.setTimeout(function(){
        try{ first && first.focus({ preventScroll:true }); }catch(error){ try{ first && first.focus(); }catch(ignore){} }
      }, 40);
      schedule();
    }
  }, true);

  window.addEventListener("ptbirthq:saved-draft-state", schedule);
  window.addEventListener("pageshow", schedule);
  window.addEventListener("resize", schedule, { passive:true });
  document.addEventListener("visibilitychange", function(){
    if(document.visibilityState !== "hidden") schedule();
  });

  new MutationObserver(schedule).observe(document.documentElement, { childList:true, subtree:true });
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule, { once:true });
  else schedule();
}());

/* Keep the editor certificate at its pre-keyboard size on every browser. */
(function(){
  "use strict";
  if(window.__ptbirthqKeyboardStageLockInstallerBound) return;
  window.__ptbirthqKeyboardStageLockInstallerBound = true;
  var editableSelector = 'input:not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="color"]),textarea,[contenteditable="true"],[role="textbox"]';

  function editableTarget(target){
    return target && target.closest ? target.closest(editableSelector) : null;
  }

  function bind(root){
    if(!root || root.__ptbirthqKeyboardStageLockBound) return;
    root.__ptbirthqKeyboardStageLockBound = true;
    var releaseTimer = 0;

    function editorOpen(){
      return root.getAttribute("data-ptbirthq-focus-mode") === "1" &&
        root.getAttribute("data-ptbirthq-purchase-flow") !== "1";
    }

    function lockStage(target){
      if(!editorOpen() || !editableTarget(target)) return;
      if(releaseTimer){ window.clearTimeout(releaseTimer); releaseTimer = 0; }
      var card = root.querySelector(".ptbirthq-stageCard");
      var width = card && card.getBoundingClientRect ? card.getBoundingClientRect().width : 0;
      if(!(width > 0)) return;
      root.style.setProperty("--ptbirthq-keyboard-stage-width", Math.round(width * 100) / 100 + "px");
      root.setAttribute("data-ptbirthq-keyboard-stage-lock", "1");
    }

    function scheduleRelease(){
      if(releaseTimer) window.clearTimeout(releaseTimer);
      releaseTimer = window.setTimeout(function(){
        releaseTimer = 0;
        if(editorOpen() && editableTarget(document.activeElement)) return;
        root.removeAttribute("data-ptbirthq-keyboard-stage-lock");
        root.style.removeProperty("--ptbirthq-keyboard-stage-width");
      }, 700);
    }

    root.addEventListener("pointerdown", function(event){ lockStage(event.target); }, true);
    try{
      root.addEventListener("touchstart", function(event){ lockStage(event.target); }, { capture:true, passive:true });
    }catch(error){
      root.addEventListener("touchstart", function(event){ lockStage(event.target); }, true);
    }
    root.addEventListener("focusin", function(event){ lockStage(event.target); }, true);
    root.addEventListener("focusout", scheduleRelease, true);
  }

  function install(){
    bind(document.getElementById("pt-birth-quick"));
  }

  install();
  new MutationObserver(install).observe(document.documentElement, { childList:true, subtree:true });
  window.addEventListener("pageshow", install);
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", install, { once:true });
}());
